import React, { useState } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Box from "@material-ui/core/Box";
import apiHelper from "../../../util/ApiHelper";
import { useLoading } from "../../../util/LoadingProvider";
import BannerTable from "./BannerTable";

const useStyles = makeStyles((theme) => ({
  tabpanel: {
    background: "#FFFFFF",
    padding: "0 20px",
  },
  box: {
    padding: 0,
    background: "#ffffff",
    paddingTop: "10px",
    paddingBottom: "10px",
    minHeight: "800px",
  },
  innerBox: {
    background: "#ffffff",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
}));

function TabPanel(props) {
  const classes = useStyles();
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      <Box p={3} className={classes.box}>
        {children}
      </Box>
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

const typeMap = {
  0: "general",
  1: "homepage",
  2: "page",
};

function BannerListingPage(props) {
  const { disabled } = props;
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(0);
  const [orderingDisabled, setOrderingDisabled] = useState(false);
  const [onChange, setOnChange] = useState(true);
  const [status, setStatus] = useState(null);
  const [rows, setRows] = useState([]);
  const [queryString, setQueryString] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [elementCounts, setElementCounts] = useState({
    all: 0,
    active: 0,
    inactive: 0,
  });

  // from child table
  const [pageSize, setPageSize] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);

  const { setLoading } = useLoading();

  const getBanners = React.useCallback(async (currentTab, currentPageSize, currentPageIndex) => {
    try {
      setLoading(true);
      console.log('getBanners state:', activeTab, currentTab, pageSize, currentPageSize, pageIndex, currentPageIndex);
      currentTab = currentTab ? currentTab : activeTab;
      currentPageSize = currentPageSize ? currentPageSize : pageSize;
      currentPageIndex = currentPageIndex ? currentPageIndex : pageIndex;
      const result = await apiHelper.hkiff.getBanners(
        typeMap[currentTab],
        null,
        currentPageIndex,
        (currentPageIndex + 1) * currentPageSize,
        currentPageSize,
        queryString,
        status
      );
      setRows(result.data.content.filter((x) => x));
      setTotalPages(result.data.totalPages);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [activeTab, status, pageIndex, pageSize, queryString, setLoading]);

  const handleChange = (event, newValue) => {
    setOnChange(true);
    setOrderingDisabled(false);
    setActiveTab(newValue);
  };

  React.useEffect(() => {
    async function refetchBannersOnChange() {
      setOnChange(false);
      try {
        const result = await apiHelper.hkiff.getBanners(
          typeMap[activeTab],
          null,
          0,
          0,
          9999999,
          queryString
        );
        const all = result.data.totalElements;
        const active = result.data.content.filter(
          (x) => x && x.status === 1 // status === 1 means active
        ).length;
        const inactive = result.data.content.filter(
          (x) => x && x.status === 0 // status === 0 means inactive
        ).length;
        console.log({ all, active, inactive });
        setElementCounts({
          all,
          active,
          inactive,
        });
      } catch (error) {
        console.log(error);
      }
    }

    if (onChange) {
      refetchBannersOnChange();
    }
  }, [activeTab, onChange, queryString]);

  React.useEffect(() => {
    if(pageSize) getBanners();
  }, [getBanners]);

  return (
    <div className={classes.content}>
      <Typography variant="h4" gutterBottom>
        Banner
      </Typography>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        general
        aria-label="Tabs of banner types"
        TabIndicatorProps={{ style: { top: "0", background: "#306F9D" } }}
      >
        <Tab label="General" {...a11yProps(0)} />
        <Tab label="Homepage" {...a11yProps(1)} />
        <Tab label="Page" {...a11yProps(2)} />
      </Tabs>
      <form>
        <TabPanel
          value={activeTab}
          index={(activeTab === 0 || 1 || 2) && activeTab}
          className={classes.tabpanel}
        >
          <BannerTable
            disabled={disabled}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            elementCounts={elementCounts}
            status={status}
            setStatus={setStatus}
            data={rows}
            setData={setRows}
            setOnChange={setOnChange}
            orderingDisabled={orderingDisabled}
            setOrderingDisabled={setOrderingDisabled}
            queryString={queryString}
            setQueryString={setQueryString}
            setParentPageIndex={setPageIndex}
            setParentPageSize={setPageSize}
            getBanners={getBanners}
            totalPages={totalPages}
            typeMap={typeMap}
          />
        </TabPanel>
      </form>
    </div>
  );
}

export default BannerListingPage;
